import api from ".";
import cookiesModifier from "../utils/cookies";

import { IDraw } from "../types/draw";

export const getDrawsByCategoryId = async (categoryId: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.get(`draws/${categoryId}`);

        return res.data as IDraw[];
    } catch (error) {
        throw error;
    }
}

export const saveDraw = async (data: IDraw) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post('draws', data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const deleteDraw = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`draws/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}